if (!customElements.get('adev-product-variants')) {
    customElements.define('adev-product-variants', class adevProductVariants extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-product-variants="carousel"]');
            this.carouselPrevButton = this.querySelector('[data-adev-product-variants="carousel-prev"]');
            this.carouselNextButton = this.querySelector('[data-adev-product-variants="carousel-next"]');
        }
        
        getlCellAlign() {
            return 'left';
        }

        getInitialIndex () {
            return 0;
        }
        
        initCarousel(){
            if (!this.carouselEl) return;

            let settings = {
                cellAlign: this.getlCellAlign(),
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: this.getInitialIndex(),
                adaptiveHeight: false,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    change: () => {
                        
                    },
                    select: () => {
                        
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();
        }

        goPrev(){
            if(this.carouselInstance){
                this.carouselInstance.previous();
            }
        }

        goNext(){
            if(this.carouselInstance){
                this.carouselInstance.next();
            }
        }

        initArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.addEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.addEventListener('click', this.goNext.bind(this));
            }
        }

        destroyArrows() {
            if (this.carouselPrevButton) {
                this.carouselPrevButton.removeEventListener('click', this.goPrev.bind(this));
            }

            if (this.carouselNextButton) {
                this.carouselNextButton.removeEventListener('click', this.goNext.bind(this));
            }
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
            }

            this.destroyArrows();
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }

    });
}